module.exports = __webpack_public_path__ + "img/video.cef38889.png";